// extracted by mini-css-extract-plugin
module.exports = {"root":"Dashboard_root__2pWAG"};